import React, { useEffect } from "react";
import ProductListing from "./ProductLogsListing";
import { columnTypes } from "src/components/UI/atoms/ATMTable/ATMTable";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import {
  setPage,
  setRowsPerPage,
  setSearchValue,
  setIsTableLoading,
  setItems,
  setTotalItems,
} from "src/redux/slices/ProductSlice";
import {
  useGetAllExcelDataQuery,
  useLazyGetDownloadErrorExcelQuery,
} from "src/services/ProductService";
import { showToast } from "src/utils/showToaster";

type Props = {};

const ProductExcelListingWrapper = (props: Props) => {
  const dispatch = useDispatch();
  const { items, totalItems, page, rowsPerPage, searchValue, isTableLoading } =
    useSelector((state: RootState) => state.product);
  const { data, isLoading, isFetching } = useGetAllExcelDataQuery({
    limit: rowsPerPage,
    searchValue: searchValue,
    params: ["productName"],
    page: page,
    filterBy: [],

    dateFilter: {},
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: true,
  });
  useEffect(() => {
    if (isLoading || isFetching) {
      dispatch(setIsTableLoading(true));
    } else {
      dispatch(setItems(data?.data || []));
      dispatch(setIsTableLoading(false));
      dispatch(setTotalItems(data?.totalItem || 0));
    }
  }, [isLoading, isFetching, data, dispatch]);
  // const moduleName = "PRODUCT";

  // const canEdit = usePermission(moduleName, "UPDATE");
  // const canDelete = usePermission(moduleName, "DELETE");
  // const canActive = usePermission(moduleName, "ACTIVE/DEACTIVE");
  const [triggerDownloadErrorExcel] = useLazyGetDownloadErrorExcelQuery();

  const handleDownloadErrorFile = async (id: string, sheetName: string) => {
    try {
      const res: any = await triggerDownloadErrorExcel(id);

      if (res?.error) {
        showToast("error", res?.error?.data?.message);
        return;
      }

      // sheetName cleanup (remove extension and (8) type suffix)
      let onlyName = sheetName.replace(/\.[^/.]+$/, ""); // remove extension
      onlyName = onlyName.replace(/\s*\(\d+\)$/, ""); // remove (8)

      const fileName = `${onlyName}_Error.xlsx`;

      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      showToast("error", "Download failed");
    }
  };

  const columns: columnTypes[] = [
    {
      field: "dateTimeUpload",
      headerName: "Uploaded Date",
      flex: "flex-[1.5_1.5_0%]",
      renderCell: (params) => (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <span>{params?.dateTimeUpload}</span>
        </div>
      ),
    },
    {
      field: "sheetName",
      headerName: "Sheet name",
      flex: "flex-[1.5_1.5_0%]",
      renderCell: (params: any) => {
        const fullName = params?.sheetName || "-";
        let onlyName = fullName.replace(/\.[^/.]+$/, "");
        onlyName = onlyName.replace(/\s*\(\d+\)$/, "");

        return onlyName;
      },
    },
    {
      field: "uploadedBy",
      headerName: "Uploaded By User",
      flex: "flex-[1.5_1.5_0%]",
    },
    {
      field: "errorRows",
      headerName: "Error Rows",
      flex: "flex-[1.5_1.5_0%]",
    },
    {
      field: "correctRows",
      headerName: "Correct Rows",
      flex: "flex-[1.5_1.5_0%]",
    },
    {
      field: "totalRows",
      headerName: "Totel Rows",
      flex: "flex-[1.5_1.5_0%]",
    },
    {
      field: "updatedRows",
      headerName: "updated Rows",
      flex: "flex-[1.5_1.5_0%]",
    },
    {
      field: "insertedRows",
      headerName: "Inserted Rows",
      flex: "flex-[1.5_1.5_0%]",
    },
    {
      field: "filePath",
      headerName: "Download (Original Sheet)",
      flex: "flex-[1.5_1.5_0%]",
      renderCell: (params) => (
        <button
          onClick={() => {
            const link = document.createElement("a");
            link.href = params?.filePath;
            link.download = "DownloadedFile.xlsx";
            document.body.appendChild(link);
            link.click();
            link.remove();
          }}
          style={{
            color: "blue",
            textDecoration: "none",
            background: "none",
            border: "none",
            cursor: "pointer",
          }}
        >
          Download
        </button>
      ),
    },
    {
      field: "errorFile",
      headerName: "Download (Error Sheet)",
      flex: "flex-[1.5_1.5_0%]",
      renderCell: (params) => (
        <button
          onClick={() =>
            handleDownloadErrorFile(params?._id, params?.sheetName)
          }
          style={{
            color: "blue",
            textDecoration: "none",
            cursor: "pointer",
          }}
        >
          Download
        </button>
      ),
    },
  ];

  return (
    <>
      <div>
        <ProductListing
          columns={columns}
          rows={items}
          paginationProps={{
            isTableLoading,
            totalItems,
            page,
            rowsPerPage,
            searchValue,
            setPage: (newPage) => dispatch(setPage(newPage)),
            setRowsPerPage: (newRowsPerPage) =>
              dispatch(setRowsPerPage(newRowsPerPage)),
            setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
          }}
        />
      </div>
    </>
  );
};

export default ProductExcelListingWrapper;
